import View from "ol/View";
import Map from "ol/Map.js";

import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {transform} from "ol/proj";

export const initializeMap = () => {
    // const mapTileVectorLayer = new TileLayer({source: new OSM()}); // Тайлы

    // Слой для точек цветка, которые отображаются при клике на группу новостей
    const vectorFlowerPoint = new VectorSource();
    vectorFlowerPoint.set("name", "flower");
    const layerFlowerPoint = new VectorLayer({
        source: vectorFlowerPoint,
    });
    layerFlowerPoint.setZIndex(10);

    // Слой для точек новостей
    const vectorNewsPoint = new VectorSource();
    vectorNewsPoint.set("name", "news");
    const layerNewsPoint = new VectorLayer({
        source: vectorNewsPoint
    });

    // Слой для карты
    const vectorMap = new VectorSource();
    vectorMap.set("name", "map");
    const layerMap = new VectorLayer({
        source: vectorMap
    });


    const view = new View({
        zoomControl: false
    });

    const map = new Map({
        view: view,
        layers: [layerMap, layerFlowerPoint, layerNewsPoint],
        target: "map",
        controls: [],
        showFullExtent: true
    });

    map.on("moveend", function() {
        map.getView().calculateExtent(map.getSize());
    });

    // Вывод координат в консоль при клике на карту
    map.on("singleclick", function (evt) {
        console.log(evt.coordinate);
        console.log(transform(evt.coordinate, "EPSG:3857", "EPSG:4326"));
    });

    // Замена курсора при наведение
    const handleHover = ((evt) => {
        let feature = map.forEachFeatureAtPixel(evt.pixel, function (feat) {
              return feat;
          }
        );

        if (feature && feature.get("type") === "news") {
            map.getTargetElement().style.cursor = "pointer";
        } else {
            map.getTargetElement().style.cursor = "";
        }
    });
    map.on("pointermove", handleHover);

    return map;
};